import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @description Vectorizes the image.
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var VectorizeEffectAction = /*#__PURE__*/function (_Action) {
  _inherits(VectorizeEffectAction, _Action);

  var _super = _createSuper(VectorizeEffectAction);

  function VectorizeEffectAction() {
    var _this;

    _classCallCheck(this, VectorizeEffectAction);

    _this = _super.call(this);
    _this._actionModel = {};
    _this._actionModel.actionType = 'vectorize';
    return _this;
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */


  _createClass(VectorizeEffectAction, [{
    key: "numOfColors",
    value: function numOfColors(num) {
      this._actionModel.numOfColors = num;
      this._numOfColors = num;
      return this;
    }
    /**
     * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
     * @param {number | string} num
     * @return {this}
     */

  }, {
    key: "detailsLevel",
    value: function detailsLevel(num) {
      this._actionModel.detailLevel = num;
      this._detailsLevel = num;
      return this;
    }
    /**
     * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
     * @param {number | string} num
     * @return {this}
     */

  }, {
    key: "despeckleLevel",
    value: function despeckleLevel(num) {
      this._actionModel.despeckleLevel = num;
      this._despeckleLevel = num;
      return this;
    }
    /**
     * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
     * @param {number | string} num
     * @return {this}
     */

  }, {
    key: "cornersLevel",
    value: function cornersLevel(num) {
      this._actionModel.cornersLevel = num;
      this._cornersLevel = num;
      return this;
    }
    /**
     * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
     * @param {number} num
     * @return {this}
     */

  }, {
    key: "paths",
    value: function paths(num) {
      this._actionModel.paths = num;
      this._paths = num;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var str = 'vectorize';

      if (this._numOfColors) {
        str += ":".concat(new QualifierValue("colors:".concat(this._numOfColors)).toString());
      }

      if (this._detailsLevel) {
        str += ":".concat(new QualifierValue("detail:".concat(this._detailsLevel)).toString());
      }

      if (this._despeckleLevel) {
        str += ":".concat(new QualifierValue("despeckle:".concat(this._despeckleLevel)).toString());
      }

      if (this._paths) {
        str += ":".concat(new QualifierValue("paths:".concat(this._paths)).toString());
      }

      if (this._cornersLevel) {
        str += ":".concat(new QualifierValue("corners:".concat(this._cornersLevel)).toString());
      }

      this.addQualifier(new Qualifier('e', str));
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          paths = actionModel.paths,
          cornersLevel = actionModel.cornersLevel,
          despeckleLevel = actionModel.despeckleLevel,
          detailLevel = actionModel.detailLevel,
          numOfColors = actionModel.numOfColors; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this();
      paths && result.paths(paths);
      cornersLevel && result.cornersLevel(cornersLevel);
      despeckleLevel && result.despeckleLevel(despeckleLevel);
      detailLevel && result.detailsLevel(detailLevel);
      numOfColors && result.numOfColors(numOfColors);
      return result;
    }
  }]);

  return VectorizeEffectAction;
}(Action);

export { VectorizeEffectAction };